import "../CSSFiles/PopUp.css"
import green_arrow from "../Images/green_arrow.png"
import React, { useRef } from 'react';

export const PopUp = (props) => {

    const PopUpRef = useRef(null)


    const CloseOutHandler = () => {
        PopUpRef.current.className += " disp_none"
    }

    const VisitHandler = () => {
        PopUpRef.current.className += " disp_none"
        document.getElementById('schedule-visit').scrollIntoView({ behavior: 'smooth'});
    }


    if (props.user_origin == "facebook_synthetic_oil_deal") {
        return;
        //  return <div className="pop-up" ref={PopUpRef}>
        //     <div className="pop-up-screen">
        //         <h3> Synthetic Oil Change Special Deal!</h3>
    
        //         <div className="pop-up-info">
        //             <div className="pop-info">
        //                 <h4> <span className="crossed-out"> Standard Industry price: $80</span></h4>
        //                 <h3> Nova Auto Repairs Guarantee: $40</h3>
        //                 <div className="special-deal">
        //                     <h2> Special Deal!</h2>
        //                     <img src={green_arrow} />
        //                 </div>
        //                 <h2> $35</h2>
        //                 <p> Find out how to get a synthetic oil change for only $35</p>

        //             </div>
        //         </div>
                
        //         <div className="pop-up-buttons">
        //             <button className="miss-out-button"  onClick={CloseOutHandler}> Miss out</button>
        //             <button className="visit-us" onClick={VisitHandler}> Find out</button>
        //         </div>
        //     </div>
        // </div>
    }


    return <div className="pop-up" ref={PopUpRef}>
         <div className="pop-up-screen">
                <h3> General Services Special Deal!</h3>
    
                <div className="pop-up-info">
                    <div className="pop-info">
                        <h3> Nova Auto Repairs Guarantee: Best prices for general services</h3>
                        <div className="special-deal">
                            <h2> Special Deal!</h2>
                            <img src={green_arrow} />
                        </div>
                        <h2> 20% OFF</h2>
                        <p> Find out how to get 20% for all general services</p>

                    </div>
                </div>
                
                <div className="pop-up-buttons">
                    <button className="miss-out-button"  onClick={CloseOutHandler}> Miss out</button>
                    <button className="visit-us" onClick={VisitHandler}> Find out</button>
                </div>
            </div>
    </div>
}